import { APP_VERSION } from "@/version";

// Utilitaire pour gérer le cache busting
export const getCacheBuster = (): string => {
  // Utilise la version de l'application ou un timestamp
  const version = APP_VERSION || Date.now().toString();
  return `v=${version}`;
};

export const addCacheBuster = (url: string): string => {
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}${getCacheBuster()}`;
};

// Fonction pour forcer le rechargement de l'application
export const forceReload = (): void => {
  // Ajoute un paramètre de cache busting à l'URL actuelle
  const currentUrl = new URL(window.location.href);
  currentUrl.searchParams.set("_t", Date.now().toString());
  window.location.href = currentUrl.toString();
};
